import axios from './axios'

//  导航菜单
export const getMenus = (params) => {
  return axios.request({
    url: '/index/menus',
    method: 'GET',
    data: params
  })
}

//  首页内容
export const getHome = (params) => {
  return axios.request({
    url: '/news/index',
    method: 'GET',
    data: params
  })
}
//  获取指定子项
export const getHomeItems = (params) => {
  return axios.request({
    url: '/news/index?menu_id=' + params.menu_id,
    method: 'GET',
  })
}
//  首页轮播内容
export const getHomeBanner= (params) => {
  return axios.request({
    url: '/banner/index',
    method: 'GET',
    data: params
  })
}

//  内容列表
export const getNewsList = (params) => {
  return axios.request({
    url: '/news/single/list',
    method: 'post',
    data: params
  })
}

//  内容列表详情
export const getNewsDetails = (params) => {
  return axios.request({
    url: '/news/detail',
    method: 'post',
    data: params
  })
}

//  友情链接
export const getFriendshiplink = (params) => {
  return axios.request({
    url: '/friendshiplink/index',
    method: 'GET',
    data: params
  })
}

// 考试公告列表
export const getExamannouncementlist = (params) => {
  return axios.request({
    url: '/examannouncement/list',
    method: 'POST',
    data: params
  })
}
// 考试公告列表详情
export const getExamannouncementDetails = (params) => {
  return axios.request({
    url: '/examannouncement/detail',
    method: 'POST',
    data: params
  })
}